import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  coverService,
  IOdbCoverDetailDivisionSummaryCategories,
  OdbCoverDetailDivision,
  OdbCoverDetailDivisionType,
} from '@dch/billing-business-logic';
import { TranslationService } from '@dch/ng-common';

export interface ICategoryClickEvent {
  division: OdbCoverDetailDivision;
  amount: string;
  category: keyof IOdbCoverDetailDivisionSummaryCategories;
}

@Component({
  selector: 'my-bill-cover-details-division',
  templateUrl: './cover-details-division.component.html',
  standalone: false,
})
export class CoverDetailsDivisionComponent {
  @Input() division: OdbCoverDetailDivision;
  @Output() categoryClick = new EventEmitter<ICategoryClickEvent>();

  constructor(private translationService: TranslationService) {}

  getItemTitle(
    identifier: string | undefined,
    category: keyof IOdbCoverDetailDivisionSummaryCategories | undefined,
    divisionType: OdbCoverDetailDivisionType
  ): string {
    return coverService.getCoverDetailItemTitle(
      identifier,
      category,
      divisionType,
      (key: string) => this.translationService.getTranslatedValueFor(key)
    );
  }

  /*
   * This is used to override the default comparator function of keyvalue pipe, which changes property order.
   */
  unsorted() {
    return 0;
  }
}
